import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Colors, CommonFonts } from '@/theme';

const useStyles = makeStyles((theme) =>
  createStyles({
    radioFormControl: {
      margin: theme.spacing(0, 5),
    },
    radioFormControlLabel: {
      ...CommonFonts.darkFont16,
    },
    title: {
      ...CommonFonts.darkFont14,
      fontWeight: 600,
    },
    collectionTypeGroup: {
      width: '100%',
    },
    formControl: {
      margin: theme.spacing(5, 0, 0, 0),
      width: '100%',
      ...CommonFonts.darkFont14,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    formControlLabel: {
      ...CommonFonts.darkFont16,
    },
    timeTitle: {
      ...CommonFonts.darkFont14,
      fontWeight: 600,
      marginTop: theme.spacing(8),
    },
  })
);

export default useStyles;
